// src/components/ReadNotificationsTable.tsx
import React, { useEffect, useState } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography,Checkbox } from "@mui/material";
import { INotification, INotificationItem, NotificationApi } from '@/api/notification-api';

export interface IMessageModel extends INotificationItem {
    id: string;
    title: string;
    content: string;
    createdAt: string;
    selected: boolean;
    expanded: boolean;
}
interface ReadNotificationsTableProps {
    data: IMessageModel[];
    onItemClick: (item: IMessageModel) => void;
    onCheckboxChange?: (item: IMessageModel) => void;
    showCheckbox: boolean;
    checkAll?: boolean;
    onSelectAll?: () => void;
}

const ReadNotificationsTable: React.FC<ReadNotificationsTableProps> = ({ data, onItemClick,onCheckboxChange,showCheckbox,checkAll,onSelectAll }) => {
    const [cb,setCb] = useState(false);
    useEffect(()=>{
        setCb(checkAll||false);
    },[checkAll]);
    return (
        <TableContainer sx={{ maxHeight: 400, overflow: "auto" }}>
            <Table>
                <TableHead sx={{ bgcolor: "#F8FAFF" }}>
                    <TableRow sx={{color:"primary.main"}}>
                        {showCheckbox &&
                        <TableCell padding="checkbox">
                            <Checkbox checked={cb} onChange={onSelectAll} />
                        </TableCell>
                        }

                        <TableCell sx={{color:"primary.main"}}>Notification</TableCell>
                        <TableCell sx={{ width: "120px",color:"primary.main" }}>Date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((item) => (
                        <TableRow key={`${item.id}-${item.selected}`}>
                            {showCheckbox &&
                            <TableCell padding="checkbox">
                                <Checkbox checked={item.selected} onChange={()=>onCheckboxChange?.(item)} />
                            </TableCell>
                            }
                            <TableCell
                                sx={{ flex: 1, cursor: "pointer" }}
                                onClick={() => onItemClick(item)}
                            >
                                <Typography variant="body1" color="#ef6c00">{item.title}</Typography>
                                <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    dangerouslySetInnerHTML={{ __html: item.content }}
                                    style={{ display: item.expanded ? "block" : "none" }}
                                />
                            </TableCell>
                            <TableCell>{item.createdAt}</TableCell>
                        </TableRow>
                    ))}
                    {data.length===0 &&
                    <TableRow>
                        <TableCell colSpan={showCheckbox?3:2} sx={{textAlign:"center"}}>There are no new notifications</TableCell>
                    </TableRow>
                    }
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default ReadNotificationsTable;